var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAllTraders = function SvgAllTraders(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 1.58,
    d: "m15.183 3.986 3.765 1.456a3.13 3.13 0 0 1 1.689 4.287l-3.923 8.098"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 1.58,
    d: "M7.32 3.29h5.592a3.95 3.95 0 0 1 3.949 3.95v9.46a4.01 4.01 0 0 1-4.01 4.01H4.668a1.3 1.3 0 0 1-1.298-1.298V7.24a3.95 3.95 0 0 1 3.95-3.95Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#00CC5D",
    fillRule: "evenodd",
    d: "M13.102 7.957c0-.33-.27-.6-.6-.6h-3.78c-.33 0-.6.27-.6.6s.27.6.6.6h2.31l-3.72 3.33c-.24.22-.26.6-.04.84s.6.26.84.04l3.8-3.42v2.55c0 .33.27.6.6.6s.6-.27.6-.6v-3.94z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#00CC5D",
    d: "M7.408 15.143a.75.75 0 0 0 0 1.5h5.415a.75.75 0 1 0 0-1.5z"
  })));
};
export default SvgAllTraders;